import { createAction } from 'redux-actions';

import { UPDATE_LOADING_MESSAGE, TOGGLE_IS_LOADING } from './constants';


const updateLoadingMessageAction = createAction(UPDATE_LOADING_MESSAGE);
const toggleIsLoadingAction = createAction(TOGGLE_IS_LOADING);

export const updateLoadingMessageRedux = (payload) => async (dispatch) => dispatch(updateLoadingMessageAction(payload));
export const toggleIsLoadingRedux = (payload) => async (dispatch) => dispatch(toggleIsLoadingAction(payload));